export const FETCH_AGENCY_DOCTORS_REQUEST = 'FETCH_AGENCY_DOCTORS_REQUEST';
export const FETCH_AGENCY_DOCTORS_SUCCESS = 'FETCH_AGENCY_DOCTORS_SUCCESS';
export const FETCH_AGENCY_DOCTORS_FAILURE = 'FETCH_AGENCY_DOCTORS_FAILURE';